import "babel-polyfill";
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/Buttons/BackToTop";

import "../styles/main.scss";

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { children } = this.props;
    const history = this.props.history;
    const location = this.props.location;

    return (
      <div className="z-1">
        <Helmet>
          <link
            rel="icon"
            type="image/icon"
            href={require("../../assets/favicon/vr-favicon.ico")}
          />
        </Helmet>
        <Header history={history} location={location} />
        {children()}
        <BackToTop />
        <Footer location={location} />
      </div>
    );
  }
}

export default TemplateWrapper;

TemplateWrapper.propTypes = {
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/layouts/index.js